import React, { memo } from "react";
import { Text, HStack, Spacer, VStack } from "@chakra-ui/react";
import UserAvatar from "modules/_shared/user-avatar";
import { MessageThreadFragment, UserFragment } from "gql/graphql";
import UserMention from "modules/_shared/mentions/user-mention";
import {
  getUserFullName,
  getUserOutOfOfficeNote,
  isUserInactive,
  isUserOutOfOffice,
  isUserSmsOnlyAndNotLoggedIn,
} from "modules/utils/Functions";
import colors from "app/colors";
import SyncoTooltip from "modules/_shared/synco-tooltip";
import {
  BellOutlineSlashIcon,
  PhoneSmsIcon,
  ReadOnlyIcon,
} from "modules/icons";

interface IProps {
  messageThread: MessageThreadFragment;
  user: UserFragment;
}

const MessageThreadProfileDrawerModeratorUser = ({
  messageThread,
  user,
}: IProps) => (
  <HStack w="full">
    <UserAvatar userId={user.id} size="sm" />
    <VStack spacing={0} alignItems="flex-start">
      <HStack spacing={1}>
        <UserMention id={user.id} />
        {isUserSmsOnlyAndNotLoggedIn(user) && (
          <Text fontSize={12} color={colors.grayMain} fontWeight={500}>
            (via SMS)
          </Text>
        )}
        {isUserInactive(user) && (
          <Text fontSize={12} color={colors.grayMain} fontWeight={500}>
            (Inactive)
          </Text>
        )}
        {isUserOutOfOffice(user) && (
          <Text fontSize={12} fontWeight={500} color={colors.grayMain}>
            ({getUserOutOfOfficeNote(user.outOfOffice)})
          </Text>
        )}
      </HStack>
      <HStack>
        <Text fontSize={12} color={colors.gray50} fontWeight={400}>
          {getUserFullName(user)}
        </Text>
        <HStack bg={colors.gray0} borderRadius={4} spacing={1} px={1} py="1px">
          <ReadOnlyIcon boxSize={3} fill={colors.gray50} />
          <Text fontSize={11} color={colors.gray50} fontWeight={600}>
            Moderator
          </Text>
        </HStack>
      </HStack>
    </VStack>
    <Spacer />
    {!messageThread.notificationUserIdList.includes(user.id) && (
      <SyncoTooltip label="Notifications muted for conversation">
        <BellOutlineSlashIcon boxSize={5} fill={colors.gray30} />
      </SyncoTooltip>
    )}
    {isUserSmsOnlyAndNotLoggedIn(user) && (
      <SyncoTooltip label="SMS Only User">
        <PhoneSmsIcon boxSize={5} fill={colors.gray30} />
      </SyncoTooltip>
    )}
  </HStack>
);

export default memo(MessageThreadProfileDrawerModeratorUser);
